const supplier = {
  supplierNo: 'SupplierNo',
  supplierName: 'SupplierName',
  tel: 'Tel',
  address: 'Address',
  supplierType: 'Type',
  contactPerson: 'ContactPerson',
  email: 'Email',
  remark: 'Remark',
  transport3PL: 'Transport3PL',
  msg: {}
};
export default supplier;



// WEBPACK FOOTER //
// ./src/page/md/supplier/lang/supplier.en.js